<template>
  <div class="accountRecharge">
    <div class="topBack">
      <el-page-header @back="goBack" content="账户充值"> </el-page-header>
    </div>
    <div class="accountRechargeMain">
      <div class="addStu">
        <el-form :inline="true" :model="formSearch" class="demo-form-inline" size="mini" @submit.native.prevent>
          <el-form-item label="">
            <div style="overflow: hidden;">
              <div class="fl">
                <el-select v-model="formSearch.region" placeholder="" @change="changeType" style="width: 130px;">
                  <el-option label="按账户查找" value="1"></el-option>
                  <el-option label="按关联学员查找" value="2"></el-option>
                </el-select>
              </div>
              <div class="fr" style="margin-left:10px;" v-if="formSearch.region === '1'">
                <el-select @change="changegAccount" v-model="formSearch.account_no" filterable remote reserve-keyword placeholder="请输入账户号码" :remote-method="remoteMethod" :loading="loading">
                  <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <!-- <el-input v-model="formSearch.account_no" placeholder="请输入账户"
                                    @input="changeAccount"></el-input> -->
              </div>
              <div style="margin-left:10px;" class="fr" v-if="formSearch.region === '2'">
                <autocomplete @getUserId="getUserId" @getUserName="getUserName"></autocomplete>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" v-if="formSearch.region == '1'" @click="addAccountRecharge">创建新账户</el-button>
            <el-button type="primary" v-else @click="addAccountRecharge1">创建新账户</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-divider></el-divider>
      <div class="boxBorder" style="margin-top: 10px;" v-if="xmAccountData.account_no != null">
        <ul class="topTxtStyle">
          <li>
            <span>充值账户：</span>
            <span>{{ xmAccountData.account_no }}</span>
          </li>
          <li>
            <span>总 余 额 ：</span>
            <span>￥{{ xmAccountData.total_amount.toFixed(2) }} (实充余额￥{{
                xmAccountData.amount.toFixed(2)
              }}，赠送余额￥{{ xmAccountData.give_amount.toFixed(2) }})</span>
          </li>
          <li>
            <div style="overflow: hidden;">
              <div class="fl">关联学员：</div>
              <div class="fl">
                <div v-for="(item, index) in xmAccountData.xmAccountStuInfoArr" :key="index">
                  {{ item.stu_realname }}
                </div>
                <div style="color: #3976f6;cursor: pointer;" @click="addStu">
                  添加关联学员
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div v-else>
        <el-empty description="请先从左上角搜索充值账户"></el-empty>
      </div>
    </div>
    <div class="accountRechargeMain" v-if="xmAccountData.account_no != null">
      <div style="font-weight: bold;">充值金额</div>
      <el-divider></el-divider>
      <div style="margin-top: 10px; padding: 10px;">
        <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini">
          <el-form-item label="实充金额">
            <el-input type="Number" oninput="if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}" v-model="formInline.rechargeAmount" placeholder="请输入实充金额">
              <span slot="prefix">￥</span>
            </el-input>
          </el-form-item>
          <el-form-item label="赠送金额" style="margin-left: 50px;">
            <el-input type="Number" oninput="if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}" v-model="formInline.give_amount" placeholder="请输入赠送金额">
              <span slot="prefix">￥</span>
            </el-input>
          </el-form-item>
        </el-form>
      </div>

      <el-divider></el-divider>
      <div style="overflow: hidden;">
        <div class="fr" style="font-size:16px;">
          应收金额：
          <span style="color:#c22925;">￥{{ formInline.rechargeAmount }}</span>
        </div>
      </div>
    </div>
    <div class="accountRechargeMain" v-if="xmAccountData.account_no != null">
      <div style="font-weight: bold;">支付信息</div>
      <el-divider></el-divider>
      <div>应收金额：￥{{ formInline.rechargeAmount }}</div>
      <div style="margin-top: 10px; padding: 10px;">
        <ul style="overflow: hidden;">
          <li class="fl borderpayment" v-for="(item, index) in paymentType" :key="index">
            <div style="overflow: hidden;">
              <div class="fl">
                <el-checkbox v-model="item.isCheck" @change="chengepaymentType">{{ item.name }}</el-checkbox>
              </div>
              <!-- @input="$forceUpdate()"  -->
              <div class="fr" v-if="item.isCheck">
                <el-input type="Number" oninput="if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}" :disabled="item.disabled" v-model="item.amountOfMoney" placeholder="请输入内容" size="mini" style="width: 100px;">
                  <span slot="suffix" style="line-height: 28px"> 元 </span>
                </el-input>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 支付宝凭证 -->
      <div v-if="isIdOneAndCheck">
        <div style="margin-top: 18px;">支付宝凭证</div>
        <div style="margin-top: 18px;">
          <el-upload action="" :http-request="uploadFileSchool" :on-remove="handleRemove1" :on-change="handleChangeFile1" :auto-upload="false" :limit="3" :file-list="zfbimgList" list-type="picture">
            <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i>
            </el-button>
            <span slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，最多上传3张
            </span>
          </el-upload>
        </div>
      </div>
      <!-- 微信凭证 -->
      <div v-if="isIdOneAndCheckvx">
        <div style="margin-top: 18px;">微信凭证</div>
        <div style="margin-top: 18px;">
          <el-upload action="" :http-request="uploadFileSchool" :on-remove="handleRemove2" :on-change="handleChangeFile2" :auto-upload="false" :limit="3" :file-list="wximgList" list-type="picture">
            <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i>
            </el-button>
            <span slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，最多上传3张
            </span>
          </el-upload>
        </div>
      </div>

      <!-- 现金凭证 -->
      <div v-if="isIdOneAndCheckxj">
        <div style="margin-top: 18px;">现金凭证</div>
        <div style="margin-top: 18px;">
          <el-upload action="" :http-request="uploadFileSchool" :on-remove="handleRemove3" :on-change="handleChangeFile3" :auto-upload="false" :limit="3" :file-list="xjimgList" list-type="picture">
            <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i>
            </el-button>
            <span slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，最多上传3张
            </span>
          </el-upload>
        </div>
      </div>
      <!-- 网银转账 -->
      <div v-if="isIdOneAndCheckwy">
        <div style="margin-top: 18px;">网银转账</div>
        <div style="margin-top: 18px;">
          <el-upload action="" :http-request="uploadFileSchool" :on-remove="handleRemove4" :on-change="handleChangeFile4" :auto-upload="false" :limit="3" :file-list="wyimgList" list-type="picture">
            <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i>
            </el-button>
            <span slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，最多上传3张
            </span>
          </el-upload>
        </div>
      </div>

      <!-- Pos机刷卡 -->
      <div v-if="isIdOneAndCheckPos">
        <div style="margin-top: 18px;">Pos机刷卡</div>
        <div style="margin-top: 18px;">
          <el-upload action="" :http-request="uploadFileSchool" :on-remove="handleRemove5" :on-change="handleChangeFile5" :auto-upload="false" :limit="3" :file-list="posimgList" list-type="picture">
            <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i>
            </el-button>
            <span slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，最多上传3张
            </span>
          </el-upload>
        </div>
      </div>

      <!-- 账户充值 -->
      <div v-if="isIdOneAndCheckzh">
        <div style="margin-top: 18px;">账户充值</div>
        <div style="margin-top: 18px;">
          <el-upload action="" :http-request="uploadFileSchool" :on-remove="handleRemove6" :on-change="handleChangeFile6" :auto-upload="false" :limit="3" :file-list="zhimgList" list-type="picture">
            <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i>
            </el-button>
            <span slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，最多上传3张
            </span>
          </el-upload>
        </div>
      </div>
      <el-divider></el-divider>
      <div style="overflow: hidden;">
        <div class="fr" style="font-size:16px;">
          实收金额：<span style="color:#c22925">{{ totalAmount }}</span>
        </div>
      </div>
    </div>
    <!-- 其他信息 -->
    <div class="accountRechargeMain" style="margin-top: 10px;">
      <div style="font-weight:bold;">其他信息</div>
      <el-divider></el-divider>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini" @submit.native.prevent>
        <el-form-item label="经办日期">
          <el-date-picker v-model="formInline.deal_date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" placement="bottom-start">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="业绩归属人">
          <el-select v-model="formInline.belongUserIdArr" multiple collapse-tags placeholder="请选择">
            <el-option v-for="item in user_list" :key="item.id" :label="item.realname + ' ' + '(' + item.name + ')'" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <br />
        <el-form-item label="对内备注">
          <el-upload action="" :http-request="uploadFileSchool" :on-remove="handleRemove" :on-change="handleChangeFile" :auto-upload="false" :limit="3" :file-list="imgList" list-type="picture">
            <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i>
            </el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
          <el-input style="width: 500px; margin-top: 15px;" type="textarea" :autosize="{ minRows: 5 }" placeholder="请输入内容" v-model="formInline.in_remark">
          </el-input>
        </el-form-item>
        <br />
        <el-form-item label="对外备注">
          <el-input style="width: 500px;" type="textarea" :autosize="{ minRows: 5 }" placeholder="请输入内容" v-model="formInline.out_remark">
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="accountRechargeMain" style="margin-top: 10px;">
      <div style="overflow: hidden;">
        <div class="fr">
          <el-button type="primary" size="small" @click="submit">确认充值</el-button>
        </div>
      </div>
    </div>
    <!-- 选择学员 -->
    <el-dialog title="创建充值账户" :visible.sync="dialogVisible1" width="30%" top="5vh">
      <el-form ref="formAccount" :model="formAccount" label-width="80px" size="mini" :rules="rules">
        <!-- <el-form-item label="校区">
          <el-select
            style="width:100%;"
            :disabled="formSearch.region == '2' ? true : false"
            v-model="formAccount.campusId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.dept_id"
              :label="item.campusName"
              :value="item.dept_id"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="手机号" prop="account_no">
          <el-input maxlength="11" v-model="formAccount.account_no" style="width:100%;" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="Cancel_ChooseStudent">取消</el-button>
        <el-button size="small" type="primary" @click="Submit_ChooseStudent('formAccount')">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="创建充值账户" :visible.sync="dialogVisible4" width="30%" top="5vh">
      <el-form ref="formAccount" :model="formAccount" label-width="80px" size="mini" :rules="rules">
        <el-form-item label="校区">
          <el-select style="width:100%;" v-model="formAccount.campusId" placeholder="请选择">
            <el-option v-for="item in options" :key="item.dept_id" :label="item.campusName" :value="item.dept_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="account_no">
          <el-input maxlength="11" v-model="formAccount.account_no" style="width:100%;" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible4 = false">取消</el-button>
        <el-button size="small" type="primary" @click="Submit_ChooseStudent1('formAccount')">确定</el-button>
      </span>
    </el-dialog>
    <!-- 选择学员1 -->
    <el-dialog title="添加关联学员" :visible.sync="dialogVisible2" width="80%" top="5vh">
      <el-form :inline="true" size="mini" label-width="500" @submit.native.prevent>
        <el-form-item label="">
          <el-input v-model="formInlineStu.user" placeholder="请输入学员姓名" style="width:250px;" @keyup.enter.native="search" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
      <div style="overflow: hidden;">
        <div class="fl" style="width: calc(70% - 5px);">
          <el-table :row-key="(row) => row.id" ref="multipleTable" :data="tabledataStu" :header-cell-style="{
              background: '#f5f7fa',
              color: '#606266',
              'font-size': '14px',
            }" stripe style="width: 100%;border:1px solid #f5f7fa;" height="55vh" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" :reserve-selection="true">
            </el-table-column>
            <el-table-column type="index" width="50" label="序号">
            </el-table-column>
            <el-table-column prop="" label="学员姓名">
              <template slot-scope="scope">
                <span>{{ scope.row.studentUserInfo.realname }}</span>
              </template>
            </el-table-column>

            <el-table-column label="性别">
              <template slot-scope="scope">
                <span>{{ scope.row.studentUserInfo.sex }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="name" label="平台账号" show-overflow-tooltip>
            </el-table-column>

            <el-table-column label="联系电话">
              <template slot-scope="scope">
                <span>{{ scope.row.studentUserInfo.parent_a }}</span><br />
                <span>{{ scope.row.studentUserInfo.parent_a_phone_num }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 30px; text-align: right">
            <el-pagination @current-change="handleCurrentChange" :current-page="page_noStu" :page-size="page_sizeStu" layout="total,prev, pager, next" :total="totalStu"></el-pagination>
          </div>
        </div>
        <div class="fl" style="margin-left: 10px;width: calc(30% - 5px);overflow-y: auto;margin-top: 0px;">
          <div style="height: calc(55vh);border: 1px solid #f5f7fa; border-radius: 5px;padding: 10px;">
            <ul>
              <li v-for="(item, index) in multipleSelection" :key="index" style="margin-bottom: 10px;border-bottom: 1px solid #f5f7fa;padding-bottom: 10px;">
                <div style="overflow: hidden;">
                  <div class="fl">{{ item.studentUserInfo.realname }}</div>
                  <div class="fr" style="cursor: pointer;" @click="deleteStu(item)">
                    <i class="el-icon-delete"></i>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible2 = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitStu">确定</el-button>
      </span>
    </el-dialog>
    <!-- 选择学员1 -->
    <el-dialog title="选择账户" :visible.sync="dialogVisible3" width="40%" top="7vh">
      <div>请选择本次要充值的账户</div>
      <el-radio-group v-model="radio" style="margin-top: 20px;">
        <el-radio @change="changeItem(item)" style="display: block;margin-bottom: 20px;" v-for="item in xmAccountList" :key="item.id" :value="item.id" :label="item.account_no">
          {{ item.account_no }}
        </el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible3 = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitStuMsg">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getFormalStudentList,
  getCampusUserList,
  getUserCampusList,
  addXmAccount,
  getXmAccountInfoByAccountNo,
  getXmAccountInfoByStuId,
  addXmAccountStu,
  addAccountRechargeOrder,
} from '@/api/educational'
import uploadFileSchool from '@/config/uploadFileSchool'
import autocomplete from '@/components/autocomplete'

import moment from 'moment'
export default {
  components: {
    autocomplete,
  },
  data() {
    return {
      xmAccountList: [],
      radio: '',
      dialogVisible3: false,
      zhimgList: [],
      posimgList: [],
      wyimgList: [],
      xjimgList: [],
      wximgList: [],
      zfbimgList: [],
      formInlineStu: {},
      dialogVisible2: false,
      dialogVisibleName: false,
      optionsStu: [],
      options1: [],
      accountList: [],
      accountList1: [],
      formSearch: {
        region: '1',
      },
      loading: false,
      xmAccountData: {},
      options: [],
      formAccount: {
        campusId: '',
      },
      user_list: [],
      imgList: [],
      //支付方式
      paymentType: [
        {
          id: '1',
          name: '支付宝',
          isCheck: false,
          amountOfMoney: 0,
          disabled: false,
        },
        {
          id: '2',
          name: '微信',
          isCheck: false,
          amountOfMoney: 0,
          disabled: false,
        },
        {
          id: '3',
          name: '现金',
          isCheck: false,
          amountOfMoney: 0,
          disabled: false,
        },
        {
          id: '4',
          name: '网银转账',
          isCheck: false,
          amountOfMoney: 0,
          disabled: false,
        },
        {
          id: '5',
          name: 'POS机刷卡',
          isCheck: false,
          amountOfMoney: 0,
          disabled: false,
        },
      ],
      //创建搜索学员
      formInline: {
        rechargeAmount: '',
      },
      page_noStu: 1,
      page_sizeStu: 10,
      totalStu: 0,
      tabledataStu: [],
      chooseStudent: {},
      dialogVisible1: false,
      dialogVisible4: false,
      multipleSelection: [],
      stuId: '',
      stuName: '',
      stuIdArr: [],
      xm_account_id: '',
      educational_institution_campus_id: '',
      account_no1: '',
      rules: {
        account_no: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '手机号格式不正确',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  watch: {},
  computed: {
    isIdOneAndCheck() {
      return this.paymentType.some((item) => item.id === '1' && item.isCheck)
    },
    isIdOneAndCheckvx() {
      return this.paymentType.some((item) => item.id === '2' && item.isCheck)
    },
    isIdOneAndCheckxj() {
      return this.paymentType.some((item) => item.id === '3' && item.isCheck)
    },
    isIdOneAndCheckwy() {
      return this.paymentType.some((item) => item.id === '4' && item.isCheck)
    },
    isIdOneAndCheckPos() {
      return this.paymentType.some((item) => item.id === '5' && item.isCheck)
    },
    isIdOneAndCheckzh() {
      return this.paymentType.some((item) => item.id === '6' && item.isCheck)
    },
    totalAmount() {
      let amount = 0
      for (let i = 0; i < this.paymentType.length; i++) {
        if (this.paymentType[i].isCheck === true) {
          console.log(this.paymentType[i].amountOfMoney, 5262323)
          amount += parseFloat(this.paymentType[i].amountOfMoney) || 0
        }
        // console.log(amount, 11212);
        // console.log(amount.toFixed(2), 11212);
      }
      return amount.toFixed(2)
    },
  },
  mounted() {
    if (this.$route.query.account_no != undefined) {
      getXmAccountInfoByAccountNo({
        account_no: this.$route.query.account_no,
        campusIdArr: JSON.stringify(this.$store.state.user.selected_schools),
      }).then((res) => {
        console.log(res, 112545)
        res.xmAccountList.map((item) => {
          this.account_no1 = item.account_no
          this.educational_institution_campus_id =
            item.educational_institution_campus_id
        })
        this.accountList1 = res.xmAccountList
        this.accountList1.map((item) => {
          console.log(item.id, 451212)
          console.log(item, 451212)
          this.xmAccountData = item
        })
      })
    }

    console.log(moment().format('YYYY-MM-DD'), 78465123)
    this.formInline.deal_date = moment().format('YYYY-MM-DD')
    this.getCampusUserList()
    this.getUserCampusList()
  },
  methods: {
    // changeaje(row) {
    //     console.log(row, 123456);
    //     this.formInline.rechargeAmount =  parseFloat(row).toFixed(2)
    // },
    // changeazs(row) {
    //     console.log(row, 123456);
    //     this.formInline.give_amount =  parseFloat(row).toFixed(2)

    // },
    handleInput3(e) {
      // 通过正则过滤小数点后两位
      e.target.value = e.target.value.match(/^\d*(\.?\d{0,1})/g)[0] || null
    },
    handleInput2(e) {
      // 通过正则过滤小数点后两位
      e.target.value = e.target.value.match(/^\d*(\.?\d{0,1})/g)[0] || null
    },
    handleInput1(e) {
      // 通过正则过滤小数点后两位
      e.target.value = e.target.value.match(/^\d*(\.?\d{0,1})/g)[0] || null
    },
    deleteStu(val) {
      this.multipleSelection.splice(this.multipleSelection.indexOf(val), 1)
      this.$refs.multipleTable.toggleRowSelection(val)
    },
    submit() {
      let payRecordArr = []
      let in_remark_img = []
      if (this.imgList.length != 0) {
        this.imgList.map((item) => {
          in_remark_img.push({
            url: item.url,
          })
        })
      }
      this.paymentType.map((item) => {
        if (item.isCheck === true) {
          console.log(item, 15212)
          payRecordArr.push({
            pay_type: item.id,
            final_amount: item.amountOfMoney,
            proof_img: JSON.stringify(item.proof_img),
          })
        }
      })
      let sumAmountOfMoney = 0
      this.paymentType.map((item) => {
        sumAmountOfMoney += parseFloat(item.amountOfMoney)
      })
      if (sumAmountOfMoney < this.formInline.rechargeAmount) {
        this.$message.warning('实收金额不能小于充值金额')
        return false
      }

      console.log(sumAmountOfMoney, 78454521)
      console.log(this.formInline.rechargeAmount, 78454521)

      console.log(this.paymentType, 78454521)
      addAccountRechargeOrder({
        payRecordArr: JSON.stringify(payRecordArr),
        xm_account_id: this.xmAccountData.id,
        deal_date: this.formInline.deal_date,
        in_remark: this.formInline.in_remark,
        in_remark_img: JSON.stringify(in_remark_img),
        out_remark: this.formInline.out_remark,
        belongUserIdArr: JSON.stringify(this.formInline.belongUserIdArr),
        total_amount: this.formInline.rechargeAmount,
        final_amount: this.totalAmount,
        amount: this.formInline.rechargeAmount,
        give_amount: this.formInline.give_amount,
      }).then((res) => {
        console.log(res, 45223)
        this.$router.push({
          name: 'ordermanagement',
        })
      })
    },
    //上传凭证 pos机
    handleRemove5() { },
    async handleChangeFile5(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss5(fileList)
      }
    },
    async uploadFileOss5(list) {
      this.uploadFileTime = true
      await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传图片')
          console.log(res)
          this.posimgList = res
          if (this.posimgList.length != 0) {
            this.paymentType.map((item) => {
              if (item.id === '5') {
                item.proof_img = []

                this.posimgList.map((item1) => {
                  item.proof_img.push({
                    url: item1.url,
                  })
                })
              }
            })
          }
          this.uploadFileTime = false
        }
      )
    },
    //上传凭证 网银
    handleRemove4() { },
    async handleChangeFile4(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss4(fileList)
      }
    },
    async uploadFileOss4(list) {
      this.uploadFileTime = true
      await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传图片')
          console.log(res)
          this.wyimgList = res
          if (this.wyimgList.length != 0) {
            this.paymentType.map((item) => {
              if (item.id === '4') {
                item.proof_img = []

                this.wyimgList.map((item1) => {
                  item.proof_img.push({
                    url: item1.url,
                  })
                })
              }
            })
          }
          this.uploadFileTime = false
        }
      )
    },
    //上传凭证 现金
    handleRemove3() { },
    async handleChangeFile3(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss3(fileList)
      }
    },
    async uploadFileOss3(list) {
      this.uploadFileTime = true
      await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传图片')
          console.log(res)
          this.xjimgList = res
          if (this.xjimgList.length != 0) {
            this.paymentType.map((item) => {
              if (item.id === '3') {
                item.proof_img = []

                this.xjimgList.map((item1) => {
                  item.proof_img.push({
                    url: item1.url,
                  })
                })
              }
            })
          }
          this.uploadFileTime = false
        }
      )
    },
    //上传凭证 微信
    handleRemove2() { },
    async handleChangeFile2(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss2(fileList)
      }
    },
    async uploadFileOss2(list) {
      this.uploadFileTime = true
      await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传图片')
          console.log(res)
          this.wximgList = res
          if (this.wximgList.length != 0) {
            this.paymentType.map((item) => {
              if (item.id === '2') {
                item.proof_img = []

                this.wximgList.map((item1) => {
                  item.proof_img.push({
                    url: item1.url,
                  })
                })
              }
            })
          }
          console.log(this.paymentType, 2323233)

          this.uploadFileTime = false
        }
      )
    },
    //上传凭证 支付宝
    handleRemove1() { },
    async handleChangeFile1(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss1(fileList)
      }
    },
    async uploadFileOss1(list) {
      this.uploadFileTime = true
      await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传图片')
          console.log(res, 2323233)
          this.zfbimgList = res
          if (this.zfbimgList.length != 0) {
            this.paymentType.map((item) => {
              if (item.id === '1') {
                item.proof_img = []
                this.zfbimgList.map((item1) => {
                  item.proof_img.push({
                    url: item1.url,
                  })
                })
              }
            })
          }
          console.log(this.paymentType, 2323233)
          this.uploadFileTime = false
        }
      )
    },
    addStu() {
      this.getFormalStudentList()
      this.dialogVisible2 = true
    },
    getUserName(val) {
      console.log(val, 455411)
      this.formAccount.campusId = val.educational_institution_campus_id
      this.stuName = val.studentUserInfo.realname
    },
    getUserId(val) {
      console.log(val, 4512)
      this.stuId = val
      if (val != '') {
        getXmAccountInfoByStuId({
          student_user_id: this.stuId,
        }).then((res) => {
          console.log(res, 4851)
          if (res.xmAccountList.length === 0) {
            this.$confirm(
              '学员' +
              `${this.stuName}` +
              '暂无关联的充值账户' +
              '是否创建账户',
              '学员暂无充值账户',
              {
                confirmButtonText: '创建账户',
                cancelButtonText: '暂不创建',
                type: 'warning',
              }
            )
              .then(() => {
                this.dialogVisible1 = true
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '取消创建',
                })
              })
          }
          if (res.xmAccountList.length > 0) {
            console.log(res.xmAccountList, 451256)
            this.xmAccountList = res.xmAccountList
            this.dialogVisible3 = true
          }
        })
      }
    },
    changeType() {
      this.xmAccountData = {}
      this.formSearch.account_no = ''
    },
    remoteMethod(query) {
      console.log(query, 54512)
      if (query !== '') {
        this.loading = true
        getXmAccountInfoByAccountNo({
          account_no: query,
          campusIdArr: JSON.stringify(this.$store.state.user.selected_schools),
        }).then((res) => {
          console.log(res, 112545)
          res.xmAccountList.map((item) => {
            this.account_no1 = item.account_no
            this.educational_institution_campus_id =
              item.educational_institution_campus_id
          })
          this.accountList1 = res.xmAccountList
          this.accountList = res.xmAccountList.map((item) => {
            return { value: `${item.id}`, label: `${item.account_no}` }
          })
          this.loading = false
          this.options1 = this.accountList.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        })
      } else {
        this.options1 = []
      }
    },
    changegAccount(val) {
      console.log(val, 451212)
      this.accountList1.map((item) => {
        console.log(item.id, 451212)
        console.log(item, 451212)
        this.xmAccountData = item
      })
    },

    submitStuMsg(val) {
      console.log(val, 545656)
      this.xmAccountList.map((item) => {
        console.log(item, 545656)
        if (this.radio === item.account_no) {
          this.xmAccountData = item
        }
      })
      this.dialogVisible3 = false
    },
    getUserCampusList() {
      getUserCampusList({}).then((res) => {
        console.log(res, 152121)
        this.options = res.userDeptList
        // this.formAccount.campusId = res.userDeptList[0].dept_id
        this.formAccount.campusId = this.$store.state.user.selected_schools[0]
      })
    },
    //获得校区员工列表
    getCampusUserList() {
      getCampusUserList({
        campusId: this.$store.state.user.selected_schools[0],
      }).then((res) => {
        console.log('获得学校用户列表')
        console.log(res)
        this.user_list = res.campusUserList
      })
    },

    //对内备注上传图片
    uploadFileSchool() { },
    handleRemove() { },
    async handleChangeFile(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList)
      }
    },
    async uploadFileOss(list) {
      this.uploadFileTime = true
      await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传图片')
          console.log(res)
          this.imgList = res
          this.uploadFileTime = false
        }
      )
    },
    //计算支付
    disablePaymentTypes(paymentTypes, isDisabled) {
      paymentTypes.forEach((item) => {
        item.disabled = isDisabled
      })
    },
    //选中支付方式
    chengepaymentType(val) {
      console.log(val, 48523)
      let selectedCount = 0
      this.paymentType.forEach((item) => {
        if (item.isCheck) {
          selectedCount++
        }
      })
      if (selectedCount === 1) {
        let checkedItem = this.paymentType.find((item) => item.isCheck) // 获取选中的支付类型
        // checkedItem.amountOfMoney = this.sumLsit1.toString().substring(1);
        checkedItem.amountOfMoney = ''
        console.log(checkedItem.amountOfMoney, 48523)
        checkedItem.amountOfMoney += parseFloat(
          this.formInline.rechargeAmount
        ).toFixed(2)
        this.paymentType.forEach((item) => {
          if (!item.isCheck) {
            item.amountOfMoney = 0
          }
        })
      }
    },
    //创建学员

    search() {
      console.log(121212, 456362)
      this.page_noStu = 1
      this.getFormalStudentList()
    },
    //查询学员
    //查询在读学员
    getFormalStudentList() {
      getFormalStudentList({
        realname: this.formInlineStu.user,
        // campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        campusIds: JSON.stringify([this.educational_institution_campus_id]),
        page_no: this.page_noStu,
        page_size: this.page_sizeStu,
      }).then((res) => {
        console.log('查询所有在读学员')
        console.log(res, 1512652)
        this.tabledataStu = res.studentList
        this.totalStu = res.total
      })
    },
    changeItem(val) {
      console.log(val, 451323)
      this.account_no1 = val.account_no
      this.educational_institution_campus_id =
        val.educational_institution_campus_id
    },
    submitStu() {
      //创建回显
      this.stuIdArr = []
      this.multipleSelection.map((item) => {
        console.log(item, 154512)
        this.stuIdArr.push(item.id)
      })
      this.addXmAccountStu()
      setTimeout(() => {
        //查询
        getXmAccountInfoByAccountNo({
          account_no: this.account_no1,
          campusIdArr: JSON.stringify([this.educational_institution_campus_id]),
        }).then((res) => {
          res.xmAccountList.map((item) => {
            this.xmAccountData = item
          })
          console.log(res, 465232)
        })
      }, 1000)

      this.dialogVisible2 = false
      console.log(this.stuIdArr, 545121)
    },
    addXmAccountStu() {
      addXmAccountStu({
        stuIdArr: JSON.stringify(this.stuIdArr),
        xm_account_id: this.xmAccountData.id,
      }).then((res) => {
        console.log(res, 4512)
        if (res.is_created === true) {
          this.$message.success('关联成功')
        }
      })
    },

    handleCurrentChange(val) {
      this.page_noStu = val
      this.getFormalStudentList()
    },
    Cancel_ChooseStudent() {
      this.dialogVisible1 = false
      console.log('取消选择学员')
    },
    Submit_ChooseStudent1(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addXmAccount({
            account_no: this.formAccount.account_no,
            campusId: this.formAccount.campusId,
          }).then((res) => {
            console.log(res, 562323)
            console.log(res.is_create, 562323)
            this.account_no1 = this.formAccount.account_no
            this.educational_institution_campus_id = this.formAccount.campusId
            if (res.is_create === undefined) {
              console.log(1111)

              this.$confirm(res.msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '关闭',
                type: 'warning',
              })
            } else {
              this.xmAccountData = res.xmAccountData
              this.$message.success('创建账户成功')
            }
          })
          this.dialogVisible4 = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    Submit_ChooseStudent(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.formSearch.region)
          this.dialogVisible2 = false
          if (this.formSearch.region == '2') {
            addXmAccount({
              account_no: this.formAccount.account_no,
              campusId: this.formAccount.campusId,
            }).then((res) => {
              this.account_no1 = this.formAccount.account_no
              this.educational_institution_campus_id = this.formAccount.campusId
              if (res.is_create === undefined) {
                console.log(1111)
                this.$confirm(res.msg, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '关闭',
                  type: 'warning',
                })
              } else {
                this.xmAccountData = res.xmAccountData
                console.log(res.xmAccountData)
                this.$message.success('创建账户成功')
                addXmAccountStu({
                  stuIdArr: JSON.stringify([this.stuId]),
                  xm_account_id: this.xmAccountData.id,
                }).then((res) => {
                  console.log(res, 4512)
                  if (res.is_created === true) {
                    setTimeout(() => {
                      //查询
                      getXmAccountInfoByAccountNo({
                        account_no: this.account_no1,
                        campusIdArr: JSON.stringify([
                          this.educational_institution_campus_id,
                        ]),
                      }).then((res) => {
                        res.xmAccountList.map((item) => {
                          this.xmAccountData = item
                        })
                        console.log(res, 465232)
                      })
                    }, 1000)
                  }
                  this.dialogVisible1 = false
                })
              }
            })
          } else {
            addXmAccount({
              account_no: this.formAccount.account_no,
              campusId: this.formAccount.campusId,
            }).then((res) => {
              this.account_no1 = this.formAccount.account_no
              this.educational_institution_campus_id = this.formAccount.campusId
              if (res.is_create === undefined) {
                this.$confirm(res.msg, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '关闭',
                  type: 'warning',
                })
              } else {
                this.xmAccountData = res.xmAccountData
                this.$message.success('创建账户成功')
              }
            })
            this.dialogVisible1 = false
            console.log(this.chooseStudent, 146523)
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addAccountRecharge() {
      this.dialogVisible1 = true
    },
    addAccountRecharge1() {
      this.dialogVisible4 = true
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    goBack() {
      this.$router.push({
        name: 'ordermanagement',
      })
    },
  },
}
</script>
<style scoped>
.accountRecharge {
  padding: 10px;
}

.topBack {
  padding: 10px;
  width: 100%;
  background: #fff;
  border-radius: 5px;
}

.accountRechargeMain {
  margin-top: 10px;
  background: #fff;
  padding: 15px;
  border-radius: 5px;
}

/deep/ .addStu .el-form-item--mini.el-form-item {
  margin-bottom: 0px;
}

/deep/ .el-divider--horizontal {
  margin: 18px 0px;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.boxBorder {
  padding: 10px;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
}

.topTxtStyle li {
  margin-bottom: 10px;
  font-size: 14px;
}

.borderpayment {
  width: 19%;
  margin-right: 10px;
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 18px;
  border-radius: 5px;
  min-height: 50px;
}
</style>
